import { CONFIG } from 'services/constants';
import { CHARGE } from '../actions';
import moment from 'moment';

const initialState = {
  branchChips: [],
  deviceChips: [],
  qrChips: [],
  minDate: moment(CONFIG.MIN_DATE),
  maxDate: moment(),
  startDate: moment().add(CONFIG.MONTH_PASS, 'M'),
  endDate: moment(),
  startAmount: 0,
  endAmount: 1000000,
  status: 'Paid',
  isFetching: false,
  data: null,
  isFetched: false,
  isError: false,
  dataError: null
};

export default (state = initialState, { type, payload, error }) => {
  switch (type) {
    case CHARGE.BRANCH_CHIP_CHANGE:
      return { ...state, branchChips: payload };

    case CHARGE.DEVICE_CHIP_CHANGE:
      return { ...state, deviceChips: payload };

    case CHARGE.QR_CHIP_CHANGE:
      return { ...state, qrChips: payload };

    case CHARGE.START_DATE_CHANGE:
      return { ...state, startDate: payload };

    case CHARGE.END_DATE_CHANGE:
      return { ...state, endDate: payload };

    case CHARGE.START_AMOUNT_CHANGE:
      return { ...state, startAmount: payload };

    case CHARGE.END_AMOUNT_CHANGE:
      return { ...state, endAmount: payload };

    case CHARGE.CHARGE_STATUS_CHANGE:
      return { ...state, status: payload };

    case CHARGE.GET_CHARGE_PENDING:
      return {
        ...state,
        isFetching: true,
        data: null,
        isFetched: false,
        isError: false,
        dataError: null
      };

    case CHARGE.GET_CHARGE_SUCCESS:
      return { ...state, isFetching: false, data: payload, isFetched: true };

    case CHARGE.GET_CHARGE_FALIED:
      return {
        ...state,
        isFetching: false,
        data: null,
        isFetched: false,
        isError: true,
        dataError: error
      };

    default:
      return state;
  }
};
